import { useEffect, useState } from "react";
import { ITreeNode } from "../../../../../../../../models/ITreeNodeData";
import { Column } from "primereact/column";
import { TableItem, TreeTablePublishableStyled } from "./styles";
import { CategoryIcon } from "../../../../../../manager-dashboard/styles";
import { managerProductLeaf } from "../../../../../../../../services/manager.service";

interface ITreeTablePublishable {
	nodes: ITreeNode[] | undefined;
}

export const TreeTablePublishable: React.FC<ITreeTablePublishable> = ({
	nodes,
}) => {
	const [tableNodes, setTableNodes] = useState(nodes);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setTableNodes(nodes);
	},[nodes])

	const onExpand = (event: any) => {
		if (!(event.node.children?.length > 0)) {
			setLoading(true);

			let params = {
				material_type: event.node.data.type.toLowerCase(),
				material_id: event.node.data.id,
			};

			managerProductLeaf(params)
				.then((response: any) => {
					let children: any = [];
					let newNodeList = tableNodes;

					response.data.forEach((node: any) => {
						let n = {
							key: node.key,
							data: node.data,
							leaf: !node.data.leaf,
						};
						if (!n.data.reason?.length) {
							children.push(n);
						}
					});

					if (event.node.data.type === "Discipline") {
						let i = newNodeList!.findIndex(
							(no) => no.key === event.node.key
						);
						if(newNodeList){
							newNodeList![i].children = children;
						}
					} else if (
						event.node.data.type === "Item" ||
						event.node.data.type === "Theme"
					) {
						const findNode = newNodeList!.findIndex(
							(node) => node.key === event.node.key
						);

						if (findNode >= 0) {
							newNodeList![findNode].children = children;
						} else {
							// Adiciona as children no event.node
							event.node.children = children;
						}
					}

					setTableNodes(newNodeList);
				})
				.finally(() => setLoading(false));
		}
	};

	const nameTemplate = (node: ITreeNode) => {
		return (
			<TableItem
				key={node.key}
				className={`${node.data.type}${
					node.independent ? " independent" : ""
				}`}
			>
				{node.data.type === `Media` &&
					node.data.category?.category_icon && (
						<CategoryIcon
							style={{
								color: "#606060",
								fontSize: 20,
							}}
							className={`material-icons-${node.data.category.category_icon}`}
						>
							<span>
								{node.data.category.category_icon.split(" ")[1]}
							</span>
						</CategoryIcon>
					)}
				<span>{node.data.title}</span>
			</TableItem>
		);
	};

	return (
		<TreeTablePublishableStyled
			value={nodes}
			onExpand={onExpand}
			loading={loading}
		>
			<Column field="title" expander body={nameTemplate}></Column>
		</TreeTablePublishableStyled>
	);
};
